const WhiteSpace = () => <span className="whiteSpace" />

export default WhiteSpace
